import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import ellipse from "../../assets/ellipse-2@2x.png";
import group42a from "../../assets/group-4@2x.png";
import vector12 from "../../assets/vector-12.svg";
import star from "../../assets/star.svg";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { Link, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { CircleLoader } from "react-spinners";
import { base_url } from "../../Global";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 470,
  bgcolor: "gray",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
};

const User = () => {
  const [open, setOpen] = React.useState(false);
  const [userId, setUserId] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubcribed, setIsSubcribed] = useState("");
  const [isBlocked, setIsBlocked] = useState("");
  const [apiCallMade, setApiCallMade] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [filteredUsers, setFilteredUsers] = useState(profiles);
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState("");

  const handleOpen = (userId, isSubcribed, isBlocked) => {
    setOpen(true);
    setUserId(userId);
    setIsSubcribed(isSubcribed);
    setIsBlocked(isBlocked);
  };

  useEffect(() => {
    const filtered = profiles.filter((profile) => {
      return (
        profile?.username?.toLowerCase().includes(search.toLowerCase()) ||
        profile?.email?.toLowerCase().includes(search.toLowerCase())
      );
    });
    setFilteredUsers(filtered);
  }, [search, profiles]);

  const fetchData = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) throw new Error("Access token not found");
      const response = await fetch(base_url + "/auth/allProfile", {
        headers: { authorization: `${accessToken}` },
      });
      if (!response.ok) throw new Error("Failed to fetch user profiles");
      const { users } = await response.json();
      setProfiles(users);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching user profiles:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    setApiCallMade(false);
  }, [apiCallMade]);

  useEffect(() => {
    const filter = searchParams.get("filter") || "all";
    if (filter === "subscribed") {
      setFilteredUsers(profiles.filter((u) => u.isSubscribed === true));
    } else if (filter === "not_subscribed") {
      setFilteredUsers(profiles.filter((u) => u.isSubscribed === false));
    } else {
      setFilteredUsers(profiles);
    }
  }, [searchParams, profiles]);

  const handleFilterChange = (e) => setSearchParams({ filter: e.target.value });

  const subscribUserProfile = async (userId, action) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await fetch(base_url + "/auth/subscriptionByAdmin", {
        method: "POST",
        headers: { "Content-Type": "application/json", authorization: `${accessToken}` },
        body: JSON.stringify({ userId, action }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        setErrorMessage("");
        fetchData();
        setApiCallMade(true);
        handleClose();
      } else {
        setErrorMessage(data.message || "An error occurred");
      }
    } catch (error) {
      setErrorMessage("Network error occurred");
    }
  };

  const deleteUserProfile = async (userId) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await fetch(base_url + "/auth/deleteUser", {
        method: "POST",
        headers: { "Content-Type": "application/json", authorization: `${accessToken}` },
        body: JSON.stringify({ userId }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        setApiCallMade(true);
        fetchData();
        handleClose();
      } else {
        setErrorMessage(data.message || "An error occurred");
      }
    } catch (error) {
      setErrorMessage("Network error occurred");
    }
  };

  const blockOrUnblock = async (userId, action) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await fetch(base_url + "/auth/blockOrUnblock", {
        method: "POST",
        headers: { "Content-Type": "application/json", authorization: `${accessToken}` },
        body: JSON.stringify({ userId, action }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        setApiCallMade(true);
        fetchData();
        handleClose();
      } else {
        setErrorMessage(data.message || "An error occurred");
      }
    } catch (error) {
      setErrorMessage("Network error occurred");
    }
  };

  const fetchSingleProfile = async (userId) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await fetch(base_url + `/auth/singleProfile/${userId}`, {
        headers: { authorization: accessToken },
      });
      if (!response.ok) throw new Error("Failed to fetch single profile");
      const data = await response.json();
      navigate(`/userProfile/${userId}`, { state: { profile: data } });
      setApiCallMade(true);
    } catch (error) {
      console.error("Error fetching single profile:", error);
    }
  };

  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (message) toast.success(message);
  }, [message]);

  return (
    <div style={{
      flex: 1,
      minHeight: "100vh",
      backgroundColor: "#374151",
      color: "white",
      padding: "24px 16px",
      boxSizing: "border-box",
      overflowX: "hidden",
    }}>
      <ToastContainer className="text-[1rem]" />

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant="h6" component="h2">Action</Typography>
          <Typography sx={{ mt: 2 }}>
            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", flexWrap: "wrap" }}>
              <button
                onClick={() => blockOrUnblock(userId, isBlocked ? "unblock" : "block")}
                style={{ padding: "8px 16px", borderRadius: "6px", border: "none", cursor: "pointer", backgroundColor: "#1f2937", color: "white" }}
              >
                {isBlocked ? "Unblock" : "Block"}
              </button>
              <button
                onClick={() => subscribUserProfile(userId, isSubcribed ? "true" : "false")}
                style={{ padding: "8px 16px", borderRadius: "6px", border: "none", cursor: "pointer", backgroundColor: "#1f2937", color: "white" }}
              >
                {isSubcribed ? "Unsubscribe" : "Subscribe"}
              </button>
              <button
                onClick={() => { deleteUserProfile(userId); handleClose(); }}
                style={{ padding: "8px 16px", borderRadius: "6px", border: "none", cursor: "pointer", backgroundColor: "#dc2626", color: "white" }}
              >
                Delete
              </button>
            </div>
          </Typography>
        </Box>
      </Modal>

      {/* ✅ HEADER ROW — stacks on mobile */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "20px",
      }}>
        {/* Title + count */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
          <h1 style={{ margin: 0, fontSize: "clamp(1.25rem, 4vw, 2rem)", textTransform: "capitalize" }}>
            Users
          </h1>
          <div style={{
            border: "0.6px solid white",
            borderRadius: "6px",
            padding: "8px 12px",
            fontSize: "14px",
          }}>
            Users: {profiles.length}
          </div>
        </div>

        {/* ✅ Search + Filter — wrap on mobile */}
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
          <input
            type="text"
            placeholder="Search by username or email"
            onChange={(e) => setSearch(e.target.value)}
            style={{
              padding: "8px 12px",
              borderRadius: "8px",
              border: "none",
              fontSize: "14px",
              minWidth: "0",
              width: "100%",
              maxWidth: "260px",
            }}
          />
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <label style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Filter:</label>
            <select
              onChange={handleFilterChange}
              value={searchParams.get("filter") || "all"}
              style={{ padding: "8px", borderRadius: "6px", border: "none", fontSize: "14px" }}
            >
              <option value="all">All</option>
              <option value="subscribed">Subscribed</option>
              <option value="not_subscribed">Not Subscribed</option>
            </select>
          </div>
        </div>
      </div>

      {/* ✅ USER LIST */}
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px" }}>
          <CircleLoader color="#4A90E2" size={50} />
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", maxHeight: "70vh", overflowY: "auto" }}>
          {Array.isArray(filteredUsers) && filteredUsers.length > 0 ? (
            filteredUsers.map((profile) => (
              <div
                key={profile._id}
                style={{
                  backgroundColor: "#1f2937",
                  borderRadius: "8px",
                  padding: "14px 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                  flexWrap: "wrap",
                  cursor: "pointer",
                }}
              >
                {/* Avatar + name */}
                <div
                  onClick={() => fetchSingleProfile(profile._id)}
                  style={{ display: "flex", alignItems: "center", gap: "16px", flex: 1, minWidth: 0 }}
                >
                  <Avatar
                    src={profile.profileImage}
                    alt={profile.username}
                    sx={{ width: 48, height: 48, flexShrink: 0 }}
                  />
                  <div style={{ minWidth: 0 }}>
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "wrap",
                      fontWeight: 500,
                      fontSize: "15px",
                    }}>
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {profile.username}
                      </span>
                      {profile.isSubscribed && (
                        <span style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "12px", color: "#fbbf24" }}>
                          <img src={star} alt="star" style={{ width: "14px" }} />
                          Prime
                        </span>
                      )}
                    </div>
                    {/* ✅ Email shown below name on mobile */}
                    <div style={{
                      fontSize: "13px",
                      color: "#9ca3af",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: "200px",
                    }}>
                      {profile.email}
                    </div>
                  </div>
                </div>

                {/* Actions button */}
                <div
                  onClick={() => handleOpen(profile._id, profile.isSubscribed, profile.isBlocked)}
                  style={{ cursor: "pointer", padding: "4px 8px", flexShrink: 0 }}
                >
                  <img
                    src={group42a}
                    alt="actions"
                    style={{ width: "6px", height: "26px", objectFit: "contain" }}
                  />
                </div>
              </div>
            ))
          ) : (
            <div style={{ textAlign: "center", padding: "40px", color: "#9ca3af" }}>
              No profiles available.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default User;